import { graphConstants } from '../constants'
import { 
  getRequestsLabelData,
  getApprovedValues,
  getRejectedValues,
  getHoldValues,
  getLabelsDoughnutGraph,
  getdataDoughnutGraph
 } from '../../utils'

export const GraphData = (state = {}, action) => {
  switch (action.type) {
    case graphConstants.GRAPHS_REQUEST:
      return { loading: true, items: undefined, error: undefined }
    case graphConstants.GRAPHS_SUCCESS:
      return {
        loading: false,
        items: action.graphData.Body,
        itemsMonthLabels: getRequestsLabelData(action.graphData.Body),
        itemsMapproved: getApprovedValues(action.graphData.Body),
        itemsMrejected: getRejectedValues(action.graphData.Body),
        itemsMonHold: getHoldValues(action.graphData.Body),
        itemsDoughnutLabels: getLabelsDoughnutGraph(action.graphData.Body),
        itemsDoughnutData: getdataDoughnutGraph(action.graphData.Body),
        error: undefined,
      }
    case graphConstants.GRAPHS_FAILURE:
      return {
        loading: false,
        items: undefined,
        error: action.error
      }
    default:
      return state
  }
}
